import * as _ from 'lodash';

export default {
    title: 'Jobs per hour',
    chartSettings: {
        type: 'line',
        options: {
            responsive: true,
            maintainAspectRatio:false,
            legend: {
                display: false
            }
        },
        data: {
            backgroundColor: 'red'
        }
    },
    mapData(data){
        return {
            labels: _.map(data, 'time'),
            datasets: [{
                backgroundColor: "#f57c00",
                data: _.map(data, 'count')
            }]
        }
    },
    fetchDataFn: 'getByHour'

}


// WEBPACK FOOTER //
// ./src/components/stats/charts/commonWidgetSettings/queuesPerHour.settings.js